import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=71825bc2&scoped=true&"
import script from "./exchange.vue?vue&type=script&lang=js&"
export * from "./exchange.vue?vue&type=script&lang=js&"
import style0 from "./exchange.vue?vue&type=style&index=0&id=71825bc2&prod&lang=scss&"
import style1 from "./exchange.vue?vue&type=style&index=1&id=71825bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71825bc2",
  null
  
)

export default component.exports